import {
  StepUpAuthentication,
  AuthenticationStepUpCache,
  AuthenticationLevel,
  SimCardFragment,
  useAuthentication,
  useAuthenticationStepUpCache,
} from "@phonero/common-ux"
import {
  PuxButton,
  PuxDialogue,
  PuxItem,
  PuxModal,
  PuxText,
  useTranslation,
} from "@phonero/pux-react"
import React from "react"

export const QrCodeDetails = ({ card }: { card: SimCardFragment }) => {
  const { t } = useTranslation()
  const [showQrCode, setShowQrCode] = React.useState(false)

  const { isAuthenticatedAtLevel } = useAuthentication(
    AuthenticationLevel.Enhanced
  )

  const {
    isCacheActive,
    cachedItem,
    clear: clearAuthenticationCache,
  } = useAuthenticationStepUpCache()

  useEffect(() => {
    if (!isCacheActive) return

    if (
      cachedItem?.context === "ShowQrCode" &&
      !!cachedItem.qrCode &&
      cachedItem.qrCode.iccid === card.iccid
    ) {
      clearAuthenticationCache()
      setShowQrCode(true)
    }
  }, [
    isCacheActive,
    cachedItem,
    card.iccid,
    setShowQrCode,
    clearAuthenticationCache,
  ])

  const getQrCodeCache = (): AuthenticationStepUpCache => ({
    context: "ShowQrCode",
    qrCode: { iccid: card.iccid || "" },
  })

  return (
    <>
      <PuxItem
        color="primary"
        type="button"
        button={true}
        onClick={() => setShowQrCode(true)}
        slot="end"
      >
        <PuxText
          style={{
            whiteSpace: "nowrap",
          }}
        >
          {t("EmbeddedSim.ShowQrCode")}
        </PuxText>
      </PuxItem>
      {/* This forces that authentication level to be according to EKOM requirement (BankId authentication). */}
      {!!showQrCode && !isAuthenticatedAtLevel && (
        <PuxModal
          isOpen={showQrCode}
          onWillDismiss={() => {
            clearAuthenticationCache()
            setShowQrCode(false)
          }}
        >
          <StepUpAuthentication
            level={AuthenticationLevel.Enhanced}
            title={t("EmbeddedSim.ShowQrCode")}
            stepUpCache={getQrCodeCache}
          >
            <></>
          </StepUpAuthentication>
        </PuxModal>
      )}
      {!!showQrCode && !!isAuthenticatedAtLevel && (
        <PuxDialogue
          title={t("EmbeddedSim.ShowQrCode")}
          isOpen={showQrCode}
          keyboardClose
          swipeToClose
          onWillDismiss={() => setShowQrCode(false)}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <PuxButton
                style={{ minWidth: 250, maxWidth: 350, marginBottom: 20 }}
                color="primary"
                {...{
                  children: t("General.Close"),
                  onClick: () => setShowQrCode(false),
                }}
              />
            </div>
          }
        >
          <div
            style={{
              textAlign: "center",
            }}
          >
            <p>{t("EmbeddedSim.ActivateInstructions")}</p>
            <div>
              {card.embeddedSimAcQrCodeUrl && (
                <img
                  src={card.embeddedSimAcQrCodeUrl}
                  width={"250px"}
                  height={"250px"}
                  style={{ marginTop: "5px", marginBottom: "5px" }}
                  alt={"QR-kode"}
                />
              )}
            </div>
            <p>
              <b>{t("EmbeddedSim.EnterManually")}</b>
            </p>
            {/* TODO: Use "--pux-color-medium", or do they have a template for these boxes? */}
            <div
              style={{
                backgroundColor: "#EDEEF0",
                borderRadius: "4px",
                padding: "10px",
                margin: "5px auto",
                maxWidth: "400px",
              }}
            >
              <div>
                <b>{t("EmbeddedSim.AcSmDpAddress")}</b>
              </div>
              <div>{card.embeddedSimAcSmDpAddress}</div>
            </div>
            <div
              style={{
                backgroundColor: "#EDEEF0",
                borderRadius: "4px",
                padding: "10px",
                margin: "5px auto",
                maxWidth: "400px",
              }}
            >
              <div>
                <b>{t("EmbeddedSim.AcToken")}</b>
              </div>
              <div>{card.embeddedSimAcToken}</div>
            </div>
          </div>
        </PuxDialogue>
      )}
    </>
  )
}
